import modalMixin from '../../mixins/_modal';
import loop from '../../components/_loop-component';

// 最大バリエーション数
const MAX_VALUES = 100;
// バリエーションデフォルト値
const DEFAULT_VALUE = {
    unselectable_flag: '0',
    option_charge: '',
    spec_value: '',
    name: '',
};

// 最大オプション数
const MAX_OPTIONS = 20;
// オプションデフォルト値
const DEFAULT_OPTION = {
    name: '',
    spec_id: '',
    values: [DEFAULT_VALUE],
};

// インスクリプションデフォルト値
const DEFAULT_INSCRIPTION = {
    name: '',
    length: '',
};

/**
 * オプション編集コンポーネント
 */
export default {
    name: 'optionEditor',
    template: '#option_editor_component_template',
    data () {
        return {
            // タイプ
            option_type: 'choices',
            // 編集モード
            edit_mode: null,
            // 編集中のindex
            edit_index: null,
            // 編集中の１オプションデータ
            edit_option: {},
        };
    },
    props: {
        // オプション設定値
        options_config: {
            type: Array,
            default: () => ([]),
            require: true
        },
        // インスクリプション設定値
        inscriptions_config: {
            type: Array,
            default: () => ([]),
            require: true
        },
    },
    components: {
        // 繰り返しコンポーネント
        'loop': loop,
    },
    computed: {
        // 編集連動中のoptions_config
        edit_options_config: {
            get() {
                return this.options_config;
            },
            set(value) {
                this.emitUpdateOptionsConfig(value);
            },
        },
        // 編集連動中のinscriptions_config
        edit_inscriptions_config: {
            get() {
                return this.inscriptions_config;
            },
            set(value) {
                this.emitUpdateInscriptionsConfig(value);
            },
        },
        // 編集対象のconfig
        edit_target_config: {
            get() {
                if (this.is_option_type_choices) {
                    return this.edit_options_config;
                } else {
                    return this.edit_inscriptions_config;
                }
            },
            set(value) {
                if (this.is_option_type_choices) {
                    this.edit_options_config = value;
                } else {
                    this.edit_inscriptions_config = value;
                }
            },
        },
        // デフォルト値
        edit_target_default_values: function () {
            if (this.is_option_type_choices) {
                // options_config用デフォルト値を返す
                return DEFAULT_OPTION;
            } else {
                // inscriptions_config用デフォルト値を返す
                return DEFAULT_INSCRIPTION;
            }
        },
        // オプション設定値は一つ以上あるか
        has_edit_options_config: function () {
            return this.options_config.length > 0;
        },
        // インスクリプション設定値は一つ以上あるか
        has_edit_inscriptions_config: function () {
            return this.inscriptions_config.length > 0;
        },
        // タイプは「選択肢」か
        is_option_type_choices: function () {
            return this.option_type === 'choices';
        },
        // 編集モードは「追加」か
        is_edit_mode_add: function () {
            return this.edit_mode === 'add';
        },
        // オプション追加ボタン表示(オプションとインスクリプションの合計が最大値を超えないようにする)
        showOptionsAddBtn: function () {
            return ((this.inscriptions_config.length + this.edit_options_config.length) < MAX_OPTIONS);
        },
        // 最大バリデーション追加数
        maxValues: function () {
            return MAX_VALUES;
        },
    },
    mixins: [
        modalMixin,
    ],
    emits: [
        'update:options_config',
        'update:inscriptions_config',
    ],
    methods: {
        // オプションバリエーション値
        defaultValue: function () {
            return _.cloneDeep(DEFAULT_VALUE);
        },
        // バリエーションタイトルの重複チェックと不可文字チェック
        valuesNameValidation: function () {
            let valid = true;
            let message = '';
            const value = this.edit_option.name;
            const ref = this.refKey('name');

            // 他オプションタイトルと重複していないかチェック(自身は除く)
            const mergedConfig = this.edit_options_config.concat(this.edit_inscriptions_config);
            const optionIndex = this.is_option_type_choices ? this.edit_index : (this.edit_index +
                this.edit_options_config.length);
            const isNotUnique = mergedConfig.filter((option, i) => {
                return ( optionIndex !== i && option.name === value);
            }).length > 0;

            if (isNotUnique) {
                message = '他のオプションタイトルと重複しています';
                valid = false;
            }
            // 不可文字チェック
            if (/[ |,<>;:&=#"\\]/.test(value)) {
                message = '半角スペース、半角記号の|,<>;:&=#"\\は入力できません';
                valid = false;
            }
            // メッセージセット
            this.setCustomMessage(ref, message);
            return valid;
        },
        // バリエーションの重複チェックと不可文字チェック
        valuesValidation: function () {
            let valid = true;
            let uniqs = [];
            const values = this.edit_option.values;
            for (const i in values) {
                let message = '';
                const value = values[i].name;
                const ref = this.refKey(i);
                // 不可文字チェック
                if (/[ |,<>;:&=#"\\]/.test(value)) {
                    message = '半角スペース、半角記号の|,<>;:&=#"\\は入力できません';
                    valid = false;
                }
                // 重複チェック
                if (uniqs.indexOf(value) != -1) {
                    message = '入力内容は重複できません';
                    valid = false;
                }
                uniqs.push(value);
                // メッセージセット
                this.setCustomMessage(ref, message);
            }
            return valid;
        },
        // refキー生成
        refKey: function (index) {
            return 'optionValuePosition' + index;
        },
        // 指定refにバリデーションメッセージをセットする
        setCustomMessage: function (ref, message) {
            this.$nextTick(() => {
                if (typeof this.$refs[ref] === 'undefined') {
                    return;
                }
                this.$refs[ref].setCustomValidity(message);
            });
        },
        // 編集モーダルを開く
        openEditor: function (optionType, index = null) {
            // indexの有無で編集モード判定
            this.edit_mode = (index === null) ? 'add' : 'edit';
            this.option_type = optionType;
            this.edit_index = index;
            // 初期化
            this.initData();
            // モーダルを開く
            this.open();
        },
        // 初期化処理
        initData: function () {
            if (this.is_edit_mode_add) {
                // 追加
                this.edit_index = this.edit_target_config.length;
                this.edit_option = _.cloneDeep(this.edit_target_default_values);
            } else {
                // 編集
                this.edit_option = this.edit_target_config[this.edit_index];
            }
        },
        // 編集モーダルを閉じる
        editClose: function () {
            // 編集変数初期化
            this.edit_index = null;
            this.edit_option = {};
            // 閉じる
            this.close();
        },
        // 保存
        save: function (event) {
            // formタグで挟んでいてHTML5のバリデーションエラーの場合はそのままフォーム送信する
            if (!event?.target?.form?.checkValidity()) {
                return;
            }
            event.preventDefault();

            // 以下カスタムバリデーション
            const hasErrorValuesName = !this.valuesNameValidation();
            const hasErrorValues = this.is_option_type_choices ? !this.valuesValidation() : false;

            if (hasErrorValuesName || hasErrorValues) {
                this.$nextTick(() => {
                    event.target.form.reportValidity();
                });
                return;
            }

            // 編集内容を反映
            this.edit_target_config[this.edit_index] = this.edit_option;

            // モーダルを閉じる
            this.editClose();
        },
        // loopコンポーネントD&D発生時処理
        changedEditOptionValues: function (values) {
            // ソート時一つ目の追加料金をリセット
            values[0].option_charge = DEFAULT_VALUE['option_charge'];
        },

        // -------------------------
        // emit
        // -------------------------

        emitUpdateOptionsConfig: function (value) {
            this.$emit('update:options_config', value);
        },

        emitUpdateInscriptionsConfig: function (value) {
            this.$emit('update:inscriptions_config', value);
        }
    }
};
